import { createContext, useContext, useMemo, useState } from "react";

const MobileNavigationContext = createContext({ open: false, setOpen: () => {} });
export function MobileNavigationProvider({ children }) {
  const [open, setOpen] = useState(false);
  const value = useMemo(() => ({ open, setOpen }), [open]);
  return <MobileNavigationContext.Provider value={value}>{children}</MobileNavigationContext.Provider>;
}
export const useMobileNavigation = () => useContext(MobileNavigationContext);
